import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import DrawerConfirm from '~/Common-Objects/UI/Drawer/DrawerConfirm'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import * as siteActions from '../../../../../../data/actions/siteActions'
import axios from '../../../../../../data/http/axios'
import Images from './images'
import Templates from './templates'
// import Lists from './lists'
import Lists from './listsV2'

export default function MailchimpConfig() {
    const [app, setApp] = useState(null)
    const [accApp, setAccApp] = useState(null)
    const [stats, setStats] = useState(null)
    const dispatch = useDispatch()
    const history = useHistory()

    const selectImages = () => {
        const content = <Images />
        dispatch(siteActions.alterSiteDrawer(true, true, 'right', content, true, '100vw'))
    }

    const selectTemplates = () => {
        const content = <Templates />
        dispatch(siteActions.alterSiteDrawer(true, true, 'right', content, true, '100vw'))
    }

    const selectLists = () => {
        const content = <Lists />
        dispatch(siteActions.alterSiteDrawer(true, true, 'right', content, true, '100vw'))
    }

    const disconnect = () => {
        const content = (
            <DrawerConfirm
                header='Disconnect Mailchimp'
                subheader='Are you sure you want to disconnect Mailchimp?'
                confirm={async () => {
                    await axios.delete('/application/account/' + accApp.id)
                    history.push('/cp/company/integrations')
                }}
            />
        )
        dispatch(siteActions.alterSiteDrawer(true, true, 'right', content, true))
    }

    useEffect(() => {
        axios.get('/application/10').then((res) => {
            setApp(res.data.Application)
        })
        axios.get('/application/account/app/10').then((res) => {
            setAccApp(res.data.Application)
        })
    }, [])

    useEffect(() => {
        if (app && accApp) {
            axios.get('/application/mailchimp/available').then((res) => {
                setStats(res.data)
            })
        }
    }, [app, accApp])

    if (!app || !accApp) return <LoadingIcons iconType='2' />

    return (
        <Row>
            <Column xs={12}>
                <Paper>
                    <Row className='middle-xs'>
                        <Column xs={8} style={{ display: 'flex', alignItems: 'center' }} className='mar-b25'>
                            <img src={app.appLogoUri} height='60' style={{ borderRadius: '50%' }} />
                            <div>
                                <p className='pad-left mar-b10 mar-t0 text-md2'>Connected to Mailchimp</p>
                                <p className='pad-left no-marg'>
                                    You can perform a manual import of your contacts, templates and images. We do not
                                    keep things automatically in sync with Mailchimp
                                </p>
                            </div>
                        </Column>
                        <Column xs={4} className='end-xs mar-b25'>
                            <Button text='Disconnect' className='button-sml grey' onClick={disconnect} />
                        </Column>
                        {!stats && (
                            <Column xs={12} className='mar-b30 col-spacer-top'>
                                <LoadingIcons iconType='2' className='mar-t30' />
                            </Column>
                        )}
                        {!!stats && (
                            <>
                                <Column xs={12} className='mar-b30 col-spacer-top'></Column>
                                <Column xs={12} md={4} className='col-md-spacer-right'>
                                    <div style={{ display: 'flex' }}>
                                        <div className='mar-r20'>
                                            <Icons
                                                circle={true}
                                                icon='avatars3'
                                                style={{ height: 30, width: 30 }}
                                                color='#7246B1'
                                            />
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 20, fontWeight: 'bold' }} className='mar-b10'>
                                                Audience
                                            </div>
                                            <div style={{ fontSize: 14 }} className='mar-b20'>
                                                {stats.lists} lists available
                                            </div>
                                            <Button
                                                text='Setup Import'
                                                className='button-md'
                                                onClick={selectLists}
                                            />
                                        </div>
                                    </div>
                                </Column>
                                <Column xs={12} md={4} className='col-md-spacer-right'>
                                    <div style={{ display: 'flex' }}>
                                        <div className='mar-r20'>
                                            <Icons
                                                circle={true}
                                                icon='template'
                                                style={{ height: 30, width: 30 }}
                                                color='#7246B1'
                                            />
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 20, fontWeight: 'bold' }} className='mar-b10'>
                                                Templates
                                            </div>
                                            <div style={{ fontSize: 14 }} className='mar-b20'>
                                                Select which campaigns to import content from
                                            </div>
                                            <Button
                                                text='Select Campaigns'
                                                className='button-md'
                                                onClick={selectTemplates}
                                            />
                                        </div>
                                    </div>
                                </Column>
                                <Column xs={12} md={4}>
                                    <div style={{ display: 'flex' }}>
                                        <div className='mar-r20'>
                                            <Icons
                                                circle={true}
                                                icon='image'
                                                style={{ height: 30, width: 30 }}
                                                color='#7246B1'
                                            />
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 20, fontWeight: 'bold' }} className='mar-b10'>
                                                Images
                                            </div>
                                            <div style={{ fontSize: 14 }} className='mar-b20'>
                                                {stats.files} files available
                                            </div>
                                            <Button
                                                text='Select Files'
                                                className='button-md'
                                                onClick={selectImages}
                                            />
                                        </div>
                                    </div>
                                </Column>
                            </>
                        )}
                    </Row>
                </Paper>
            </Column>
        </Row>
    )
}
